import useSearchFilter from "@src/shared/context/searchfilter/useSearchFilter";
import { ISort } from "@src/shared/context/sort/ISort";
import { useSortOptions } from "@src/shared/context/sort/Options";
import * as React from "react";
import { useIntl } from "react-intl";

import SingleChoiceFilter from "./filter/singlechoicefilter/SingleChoiceFilter";
import * as sc from "./SearchSort.sc";

interface ISearchSort {
    caption?: string;
    variant?: "default" | "dark" | "sort";
}

const SearchSort: React.FunctionComponent<ISearchSort> = ({ caption, variant = "sort" }) => {
    const intl = useIntl();
    const { filter, setSort } = useSearchFilter();
    const sortOptions = useSortOptions();
    const currentValue = filter.sort && filter.sortOrder ? { sort: filter.sort, sortOrder: filter.sortOrder } : undefined;

    return (
        <sc.CaptionContainer caption={caption}>
            <SingleChoiceFilter<ISort>
                value={currentValue}
                options={sortOptions}
                onChange={(sort) => setSort?.(sort)}
                isSearchable={false}
                placeholder={intl.formatMessage({
                    id: "leaseme.sort",
                    defaultMessage: "Sortieren",
                })}
                variant={variant}
            />
        </sc.CaptionContainer>
    );
};

export default SearchSort;
